// extracted by mini-css-extract-plugin
module.exports = {"instruction":"write-us-btn_instruction__9JEwv","hint":"write-us-btn_hint__cFuQX"};